import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {
	className?: string;
}

const NavActiveIcon: React.FC<IProps> = (props) => {
	return (
		<svg
			width="41"
			height="8"
			viewBox="0 0 41 8"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M1 6.99387C1.68301 3.37658 5.7982 0.849678 10.75 1.00695C15.4626 1.15663 14.9786 6.79026 19.6875 6.99387C23.6564 7.16549 24.667 3.67802 28.625 3.40172C33.4364 3.06585 37.0118 4.19494 40 6.99387"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
			/>
		</svg>
	);
};

export default memo(NavActiveIcon);
